import React, { useContext } from 'react';
import { Button } from '@wds/button';
import { T, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { generateMetricsAttribute } from '@sm/metrics';
import HeaderContext from '../../HeaderContext';
import { StaticContext } from '../../../../StaticContext';
import ButtonCreateVariant, { ExperimentVariant } from './ButtonCreateVariant';

export const COPY = defineMessages({
  CREATE_SURVEY: {
    id: 'ButtonCreate.createSurvey',
    defaultMessage: 'Create survey',
    description:
      '[Type: Label][Vis.: high] - This is the create survey addon button on the header.',
  },
});

const ButtonCreate = () => {
  const { pageURL, pageName } = useContext(HeaderContext);
  const { HEADER_EXP = {} } = useContext(StaticContext);
  const experimentTreatment = HEADER_EXP?.createSurveyButton?.treatment;

  if (Object.values(ExperimentVariant).includes(experimentTreatment)) {
    return <ButtonCreateVariant treatment={experimentTreatment} />;
  }

  return (
    <Button
      size="sm"
      color="alt"
      href={createURL('/create/', { ut_source: 'header' })}
      data-sm-metrics={generateMetricsAttribute({
        data: {
          url: pageURL,
          pageName,
          amplitudeEvent: 'header clicked cta',
          ctaName: 'create survey',
        },
      })}
    >
      <T desc={COPY.CREATE_SURVEY} />
    </Button>
  );
};

export default ButtonCreate;
